/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Grid,
  Button as MaterialButton,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PageTitle from 'components/PageTitle';
import RefreshButton from 'components/RefreshButton';
import TableItems, {
  MenuActionItem,
  MenuActions,
  StatusIcon,
  TableCell,
  TableRow,
} from 'components/TableItems';
import Permission from 'components/ValidPermission';
import i18n from 'i18n';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import {
  getAllOperatorsRequest,
  removeOperatorRequest,
  resetMFAToOperatorRequest,
  toggleBlockOperatorRequest,
  updateMFARequest,
} from 'modules/operators/actions';
import { GetOperatorFields, ListDataProps } from 'modules/operators/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Roles from 'router/rolesDictionary';
import ApplicationState from 'store/interfaces';
import { formatDateWithMoment } from 'utils/helpers';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import Button from 'components/Button';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import ResetModal from '../Form/PasswordResetModal';
import styles from './styles';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoading: boolean;
  operatorList: ListDataProps;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  getAllOperatorsRequest: (props) => void;
  removeOperatorRequest: (props) => void;
  resetMFAToOperatorRequest: ({ operator_uuid, query }) => void;
  updateMFARequest: ({ operatorUuid, mfaChange, isForm }) => void;
  toggleBlockOperatorRequest: (props: {
    operator_uuid: string;
    blocked: boolean;
    query?: typeof initialQuery;
  }) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
}

const OperatorsList = ({
  isLoading,
  operatorList,
  role,
  companySelected,
  removeOperatorRequest,
  getAllOperatorsRequest,
  toggleBlockOperatorRequest,
  resetMFAToOperatorRequest,
  updateMFARequest,
  modalOpen,
  modalClose,
}: Props) => {
  const classes = useStyles();

  const {
    itemOrder,
    query,
    searchValue,
    setQuery,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);
  const [refresh, setRefresh] = React.useState(false);
  const [listSwitch, setListSwitch] = React.useState(false);

  const handleRemoveOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('OPERATORS_PAGE.REMOVE_OPERATOR_TITLE_KEY', {
        name: `${operator?.first_name} ${operator?.last_name}`,
      }),
      content: i18n.t('OPERATORS_PAGE.REMOVE_OPERATOR_DESCRIPTION_KEY'),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              removeOperatorRequest(operator?.operator_uuid);
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const handleToggleBlockOperator = (operator: GetOperatorFields) => {
    const { operator_uuid, blocked, first_name, last_name } = operator;
    modalOpen({
      title: i18n.t(
        blocked
          ? 'OPERATORS_PAGE.UNBLOCK_OPERATOR_TITLE_KEY'
          : 'OPERATORS_PAGE.BLOCK_OPERATOR_TITLE_KEY'
      ),
      content: i18n.t(
        blocked
          ? 'OPERATORS_PAGE.UNBLOCK_OPERATOR_DESCRIPTION_KEY'
          : 'OPERATORS_PAGE.BLOCK_OPERATOR_DESCRIPTION_KEY',
        {
          name: `${first_name} ${last_name}`,
        }
      ),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              toggleBlockOperatorRequest({
                operator_uuid,
                blocked: !blocked,
                query,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const resetPasswordOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('RESET_PASSWORD_OPERATOR_KEY'),
      content: <ResetModal operator={operator} onCancel={modalClose} />,
      noBorder: true,
    });
  };

  const resetMFAOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('MFA_RESET_KEY'),
      content: i18n.t('OPERATORS_PAGE.RESET_MFA_OPERATOR_KEY', {
        firstName: operator?.first_name,
        lastName: operator?.last_name,
      }),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              resetMFAToOperatorRequest({
                operator_uuid: operator?.operator_uuid,
                query,
              });
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const getOperators = (refresh = false) => {
    getAllOperatorsRequest({
      ...query,
    });

    setRefresh(refresh);
  };

  const enableMFAOperator = (operator: GetOperatorFields) => {
    modalOpen({
      title: i18n.t('ACTIVATE_MFA_KEY'),
      content: i18n.t('ACTIVATE_MFA_MODAL_MESSAGE_KEY', {
        firstName: operator?.first_name,
        lastName: operator?.last_name,
      }),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              updateMFARequest({
                operatorUuid: operator?.operator_uuid,
                mfaChange: !operator?.mfa_required,
                isForm: false,
              });
              modalClose();
              getOperators(true);
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const handleGetOperators = (search: string) => {
    getAllOperatorsRequest({
      ...query,
      search,
    });
    setListSwitch(true);
  };

  React.useEffect(() => {
    getOperators();
  }, [query]);

  const headers = [
    {
      key: 'name',
      i18n: 'FULL_NAME_KEY',
      style: { width: 150 },
      order: true,
    },
    {
      key: 'email',
      i18n: 'EMAIL_KEY',
      style: { width: 150 },
      order: true,
    },
    {
      key: 'company',
      i18n: 'COMPANY_KEY',
      style: { width: 100 },
      order: true,
    },
    {
      key: 'user__last_login',
      i18n: 'LAST_LOGIN_DATE_KEY',
      style: { width: 100 },
      order: true,
      centerTitle: true,
    },
    {
      key: 'blocked',
      i18n: 'STATUS_KEY',
      style: { width: 30, padding: '0px 5px' },
      order: true,
      centerTitle: true,
    },
    {
      key: 'role',
      i18n: 'PROFILE_KEY',
      style: { width: 100 },
      order: true,
      centerTitle: true,
    },
  ];

  return (
    <Grid container>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <PageTitle
          title={i18n.t('OPERATORS_PAGE.LIST_OPERATORS_TITLE_KEY')}
          subtitle={i18n.t('OPERATORS_PAGE.LIST_OPERATORS_SUBTITLE_KEY')}
        />

        <Grid item>
          <RefreshButton
            id="btn-refresh"
            onClick={() => getOperators(true)}
            animate={isLoading}
            className={classes.refreshButton}
            disabled={isLoading}
          />

          <Permission value="create_new_operator">
            <MaterialButton
              id="new-operator"
              variant="contained"
              color="secondary"
              size="large"
              className={clsx({
                [classes.addButtonGreen]: inAdminView(role, companySelected),
                [classes.addButtonGray]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [classes.addButtonBlue]: inOperatorView(role, companySelected),
                [classes.addButtonYellow]: companySelected,
              })}
              startIcon={<PersonAddIcon className={classes.addButtonIcon} />}
              component={Link}
              to="/operators/new"
            >
              {i18n.t('OPERATOR_KEY')}
            </MaterialButton>
          </Permission>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.searchContainer}>
        <Grid item className={classes.searchSize}>
          <SearchBar
            id="search-operators"
            isLoading={isLoading}
            searchValue={searchValue}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
            onSearchComplete={() => setListSwitch(true)}
          />
        </Grid>
        <Grid item className={classes.buttonsGrid}>
          <Button
            className={clsx(classes.searchButtonSize, {
              [classes.buttonIsLoading]: isLoading,
            })}
            id="search-all-operators"
            variant="outlined"
            onClick={() => {
              handleGetOperators(searchValue);
            }}
            disabled={isLoading}
          >
            <Typography className={classes.listAll}>
              {i18n.t('SEARCH_ALL_KEY')}
            </Typography>
          </Button>
          <Button
            className={clsx(classes.listButtonSize, {
              [classes.buttonIsLoading]: isLoading,
            })}
            id="list-all-operators"
            variant="outlined"
            disabled={isLoading}
            pressed={listSwitch}
            onClick={() => {
              if (listSwitch === false) {
                getOperators();
                setListSwitch(!listSwitch);
                setQuery(initialQuery);
              } else {
                setListSwitch(!listSwitch);
                setQuery(initialQuery);
              }
            }}
          >
            <Typography className={classes.listAll}>
              {i18n.t('LIST_ALL_KEY')}
            </Typography>
          </Button>
        </Grid>
      </Grid>

      <Grid container className={classes.searchContainer}>
        {listSwitch && (
          <TableItems
            header={
              <>
                {headers.map(item => (
                  <TableCell
                    centerTitle={item?.centerTitle}
                    key={item?.key}
                    markOderItem={itemOrder === item?.key}
                    order={item?.order}
                    style={item?.style || {}}
                    handleOrder={() =>
                      item?.order ? handleOrder(item?.key) : null
                    }
                  >
                    {i18n.t(item?.i18n)}
                  </TableCell>
                ))}
                <TableCell centerTitle>{i18n.t('ACTIONS_KEY')}</TableCell>
              </>
            }
            renderItems={(item, index) => (
              <TableRow key={item?.operator_uuid}>
                <TableCell
                  maxLength={25}
                  ellipsis
                  className={classes.textField}
                >
                  {`${item?.first_name} ${item?.last_name}`}
                </TableCell>
                <TableCell
                  ellipsis
                  copyable
                  tooltip={item?.email}
                  className={clsx({
                    [classes.textField]: item?.email,
                  })}
                >
                  {item?.email}
                </TableCell>
                <TableCell
                  maxLength={15}
                  ellipsis
                  tooltip={item?.company?.company_name}
                  className={clsx({
                    [classes.textField]: item?.company?.company_name,
                  })}
                >
                  {item?.company?.company_name}
                </TableCell>
                <TableCell
                  centerTitle
                  textAlignCenter
                  className={classes.dateField}
                >
                  {formatDateWithMoment(item?.last_login)}
                </TableCell>
                <TableCell
                  className={classes.statusContent}
                  centerTitle
                  tooltip={i18n.t(
                    item?.blocked
                      ? 'STATUS_OPERATOR_BLOCKED_KEY'
                      : 'STATUS_OPERATOR_ACTIVE_KEY'
                  )}
                >
                  {item?.blocked ? (
                    <Grid container justify="center">
                      <StatusIcon status="blocked" />
                    </Grid>
                  ) : (
                    <Grid container justify="center">
                      <StatusIcon status="success" />
                    </Grid>
                  )}
                </TableCell>
                <TableCell
                  textAlignCenter
                  maxLength={20}
                  ellipsis
                  className={classes.centerItem}
                >
                  {Roles[item?.role]}
                </TableCell>
                <TableCell
                  centerTitle
                  textAlignCenter
                  className={classes.editOperator}
                >
                  <MenuActions id={`btn-options-operators-${index}`}>
                    <Permission value="edit_operator_details">
                      <MenuActionItem
                        id="btn-edit-operator"
                        component={Link}
                        to={`/operators/${item?.operator_uuid}/edit`}
                      >
                        {i18n.t('EDIT_OPERATOR_KEY')}
                      </MenuActionItem>
                    </Permission>

                    <MenuActionItem
                      id="btn-block-unblock-operator"
                      onClick={() => handleToggleBlockOperator(item)}
                    >
                      {i18n.t(
                        `BLOCK_${String(
                          item?.blocked
                        ).toUpperCase()}_OPERATOR_KEY`
                      )}
                    </MenuActionItem>
                    <Permission value="delete_operator">
                      <MenuActionItem
                        id="btn-remove-operator"
                        onClick={() => handleRemoveOperator(item)}
                      >
                        {i18n.t('REMOVE_OPERATOR_KEY')}
                      </MenuActionItem>
                    </Permission>

                    <MenuActionItem
                      id="btn-reset-password-operator"
                      onClick={() => resetPasswordOperator(item)}
                    >
                      {i18n.t('RESET_PASSWORD_KEY')}
                    </MenuActionItem>
                    {!!item?.mfa_required && (
                      <Permission value="reset_operator_mfa">
                        <MenuActionItem
                          id="btn-reset-MFA-operator"
                          onClick={() => resetMFAOperator(item)}
                        >
                          {i18n.t('MFA_RESET_KEY')}
                        </MenuActionItem>
                      </Permission>
                    )}

                    {item?.role === 'client_operator' && !item?.mfa_required && (
                      <Permission value="reset_operator_mfa">
                        <MenuActionItem
                          id="btn-toggle-MFA-operator"
                          onClick={() => enableMFAOperator(item)}
                        >
                          {i18n.t('ACTIVATE_MFA_KEY')}
                        </MenuActionItem>
                      </Permission>
                    )}
                  </MenuActions>
                </TableCell>
              </TableRow>
            )}
            data={operatorList}
            isLoading={!refresh && isLoading}
            onChangePage={handlePageChange}
            onChangeLimit={handleLimitChange}
            notFoundText={i18n.t('NO_OPERATOR_KEY')}
          />
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
  operators: { isLoading, operatorList },
}: ApplicationState) => ({
  isLoading,
  operatorList,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {
  toggleBlockOperatorRequest,
  getAllOperatorsRequest,
  removeOperatorRequest,
  resetMFAToOperatorRequest,
  updateMFARequest,
  modalOpen,
  modalClose,
})(OperatorsList);
